import { twMerge } from 'tailwind-merge';
import React, { type InputHTMLAttributes } from 'react';
import { isIosDevice } from '../../helpers/utils';

interface UpInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  label?: string;
  error?: string;
  className?: string;
}

const UpInput: React.FC<UpInputProps> = ({
  label,
  error,
  placeholder,
  className = '',
  ...props
}) => {
  const handleInputFocus = (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    if (isIosDevice()) {
      return;
    }
    const el = e?.target;
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      }, 200);
    }
  };

  return (
    <div className={twMerge('w-full max-w-lg', className)}>
      {label && <label className="block text-sm mb-1.5">{label}</label>}
      <input
        type="text"
        placeholder={placeholder}
        onFocus={handleInputFocus}
        className={twMerge(
          'w-full p-3 text-sm font-normal text-up-black-80 placeholder-up-black-50 border border-up-black-20 rounded-lg focus:outline-none focus:ring-1 focus:ring-up-black-80 focus:border-transparent transition-colors duration-200 disabled:bg-up-black-10 disabled:cursor-not-allowed',
          error ? 'border-up-red-50 focus:ring-up-red-50' : '',
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm font-normal text-up-red-50">{error}</p>
      )}
    </div>
  );
};

export default UpInput;
